import { asHintId, type Hint } from '@/shared/stores';

import { COPILOT_COMPOSER_ANCHOR } from './anchors';

export const cortexComposerHint: Hint = {
  id: asHintId('patient-workspace:cortex-composer'),
  version: 1,
  priority: 50,
  anchor: COPILOT_COMPOSER_ANCHOR,
  copy: {
    title: 'Ask Cortex anything',
    body: 'Cortex sees everything you see — labs, requests, the chart. Ask for a draft, a follow-up, or a quick second opinion.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
